import { GoogleFreeBookingLinksHotelType } from "@/lib/gql/__generated__/graphql";

import { FeatureIslandMainWithBackGround } from "@/components/features/_layouts";

import { useGoogleFreeBookingLinksSettingsContext } from "../_context";
import {
	AccordionFeatureDescription,
	FormAddress,
	FormChillnnGuestPageType,
	FormConnectionStatus,
	FormDefaultPlan,
	FormHotelName,
	FormHotelType,
	FormPhoneNumbers,
	FormWebsite,
} from "./components";

export const Form = () => {
	const { form } = useGoogleFreeBookingLinksSettingsContext();

	const hotelType = form.watch("hotelType");

	const isHotel = hotelType === GoogleFreeBookingLinksHotelType.Hotel;

	return (
		<>
			<FeatureIslandMainWithBackGround>
				<AccordionFeatureDescription />
			</FeatureIslandMainWithBackGround>

			<FeatureIslandMainWithBackGround>
				<div className="space-y-14">
					<FormConnectionStatus />
					<FormHotelType />

					{isHotel ? (
						<>
							<FormHotelName />
							<FormDefaultPlan />
							<FormAddress />
							<FormPhoneNumbers />
							<FormChillnnGuestPageType />
							<FormWebsite />
						</>
					) : (
						<p>現在、ホテル以外の宿泊施設は Google 無料予約リンクの設定ができません。</p>
					)}
				</div>
			</FeatureIslandMainWithBackGround>
		</>
	);
};
